import MainPageFinanceiro from '@/screens/financeiro/MainPage'
import HomeFinanceiro from '@/screens/financeiro/Home'
import CadastroProcessoFisico from '@/screens/financeiro/processoFisico/CadastroProcessoFisico'
import CadastroProcessoUpfpa from '@/screens/financeiro/upfpa/processoUpfpa'

import VisualizarProcessoFisico from '@/screens/financeiro/processoFisico/VisualizarProcessoFisico'
import ListagemDaes from '@/screens/financeiro/processoFisico/ListagemDaes'
import CadastroDae from '@/screens/financeiro/dae/CadastroDae'
import ResumoDae from '@/screens/financeiro/dae/ResumoDae'
import RelatoriosDae from '@/screens/financeiro/relatoriosDae/RelatoriosDae.vue'
import PERFIL from '@/constants/perfil'

import HomeVtn from '@/screens/financeiro/vtn/Home'
import DadosVtn from '@/screens/financeiro/vtn/DadosVtn'
import CalculoBoleto from '@/screens/central/components/vtn/AppCalculoVtn'
import FormaPagamento from '@/screens/financeiro/vtn/FormaPagamento'
import ResumoVtn from '@/screens/financeiro/vtn/ResumoVtn'
import CustasVtn from '@/screens/financeiro/vtn/CustasVtn'
import InformacoesSolicitadas from '@/components/CaixaInformacoesListagem'
import ResponderInformacao from '@/screens/analise/ResponderInformacoes'
import CaixaGestaoVtnListagem from '@/screens/analise/listagem/CaixaGestaoVtnListagem'
import DetalhesProcesso from '@/screens/central/processos/DetalhesProcesso'
import VisualizarDAEs from '@/screens/analise/VisualizarDAEsGestaoVtn'
import EmitirDae from '@/screens/analise/EmitirDaeParcela'
import EmissaoCertidaoQuitacao from '@/screens/financeiro/EmissaoCertidaoQuitacao'

import store from '@/store'

const ROUTE_HOME = store.state.userInterface.dadosEstado.FINANCEIRO.ROUTE_HOME

const setRouteGroup = (group) => {
  return { routeGroup: group }
}
const setParentRouteGroup = group => {
  return { parentRouteGroup: group }
}

const perfisFinanceiro = [PERFIL.FINANCEIRO.ANALISTA_COF.codigo, PERFIL.FINANCEIRO.COORDENADOR_COF.codigo, PERFIL.FINANCEIRO.FINANCEIRO.codigo]

const financeiro = [
  {
    path: '/financeiro',
    component: MainPageFinanceiro,
    redirect: { name: ROUTE_HOME },
    children: [
      {
        path: 'home',
        name: 'financeiro/home',
        component: HomeFinanceiro,
        meta: {
          perfis: perfisFinanceiro,
          ...setRouteGroup('FINANCEIRO_CAIXA_DE_ENTRADA')
        }
      },
      {
        path: 'home',
        name: 'cof/home',
        redirect: { name: 'financeiro/home' },
        component: HomeFinanceiro,
        meta: {
          perfis: perfisFinanceiro,
          ...setRouteGroup('FINANCEIRO_CAIXA_DE_ENTRADA')
        }
      },
      {
        path: 'upfpa',
        name: 'cof/upfpa',
        component: CadastroProcessoUpfpa,
        meta: {
          perfis: perfisFinanceiro,
          ...setRouteGroup('COF_UPFPA')
        }
      },
      {
        path: 'cadastroProcessoFisico',
        name: 'cof/cadastroProcessoFisico',
        component: CadastroProcessoFisico,
        meta: {
          perfis: perfisFinanceiro,
          ...setRouteGroup('FINANCEIRO_CAIXA_DE_ENTRADA')
        }
      },
      {
        path: 'relatorios',
        name: 'dae/relatorios',
        component: RelatoriosDae,
        meta: {
          perfis: perfisFinanceiro,
          ...setRouteGroup('FINANCEIRO_RELATORIOS')
        }
      },
      {
        path: 'informacoesSolicitadas',
        name: 'cof/informacoesSolicitadas',
        component: InformacoesSolicitadas,
        meta: {
          perfis: perfisFinanceiro,
          ...setRouteGroup('COF_INFORMACOES_SOLICITADAS')
        }
      },
      {
        path: 'gestaoVtn',
        name: 'cof/gestaoVtn',
        component: CaixaGestaoVtnListagem,
        meta: {
          perfis: perfisFinanceiro,
          ...setRouteGroup('COF_GESTAO_VTN')
        }
      },
      {
        path: 'VISUALIZAR_DAES/:idProcesso',
        name: 'VISUALIZAR_DAES_COF',
        component: VisualizarDAEs,
        props: true,
        meta: {
          isPublic: false,
          routeGroup: 'DAE_VTN',
          perfis: perfisFinanceiro,
          ...setRouteGroup('COF_GESTAO_VTN')
        }
      },
      {
        path: 'EMITIR_CERTIDAO/:idProcesso',
        name: 'EMITIR_CERTIDAO',
        component: EmissaoCertidaoQuitacao,
        props: true,
        meta: {
          isPublic: false,
          routeGroup: 'DAE_VTN',
          perfis: perfisFinanceiro,
          ...setRouteGroup('COF_GESTAO_VTN')
        }
      },
      {
        path: 'detalhesProcesso',
        name: 'detalhesProcesso',
        component: DetalhesProcesso,
        props: true,
        children: [
          {
            path: 'calculoPagamento/:idVtn',
            name: 'calculoPagamento',
            component: CalculoBoleto,
            props: true,
            meta: {
              perfis: perfisFinanceiro,
              ...setRouteGroup('COF_GESTAO_VTN'),
              ...setParentRouteGroup('COF_GESTAO_VTN')
            }
          }
        ]
      },
      {
        path: 'emitirDae/vtn/:idProcesso',
        name: 'emitirDae',
        component: EmitirDae,
        props: true,
        meta: {
          isPublic: false,
          routeGroup: 'COF_GESTAO_VTN'
        }
      },
      {
        path: 'informacoes/:idSolicitacao',
        name: 'cof/informacoes',
        component: ResponderInformacao,
        props: true,
        meta: {
          perfis: perfisFinanceiro,
          ...setRouteGroup('COF_INFORMACOES_SOLICITADAS')
        }
      },
      {
        path: 'visualizarProcessoFisico/:numeroProcesso',
        name: 'cof/visualizarProcessoFisico',
        props: true,
        redirect: { name: 'cof/visualizarProcessoFisico/dae' },
        component: VisualizarProcessoFisico,
        meta: {
          perfis: perfisFinanceiro,
          ...setRouteGroup('FINANCEIRO_CAIXA_DE_ENTRADA')
        },
        children: [
          {
            path: 'daes',
            name: 'cof/visualizarProcessoFisico/dae',
            component: ListagemDaes,
            meta: {
              perfis: perfisFinanceiro,
              ...setRouteGroup('FINANCEIRO_CAIXA_DE_ENTRADA')
            }
          },
          {
            path: 'vtn',
            name: 'cof/vtn',
            component: HomeVtn,
            redirect: { name: 'vtn/dadosVtn' },
            meta: {
              perfis: perfisFinanceiro,
              ...setRouteGroup('FINANCEIRO_CAIXA_DE_ENTRADA')
            },
            children: [
              {
                path: 'dadosVtn',
                name: 'vtn/dadosVtn',
                component: DadosVtn,
                props: true,
                meta: {
                  perfis: perfisFinanceiro,
                  ...setRouteGroup('FINANCEIRO_CAIXA_DE_ENTRADA')
                }
              },
              {
                path: 'custas',
                name: 'vtn/custas',
                component: CustasVtn,
                meta: {
                  perfis: perfisFinanceiro,
                  ...setRouteGroup('FINANCEIRO_CAIXA_DE_ENTRADA')
                }
              },
              {
                path: 'pagamento',
                name: 'vtn/pagamento',
                component: FormaPagamento,
                meta: {
                  perfis: perfisFinanceiro,
                  ...setRouteGroup('FINANCEIRO_CAIXA_DE_ENTRADA')
                }
              },
              {
                path: 'dadosVtn',
                name: 'vtn/resumo',
                component: ResumoVtn,
                meta: {
                  perfis: perfisFinanceiro,
                  ...setRouteGroup('FINANCEIRO_CAIXA_DE_ENTRADA')
                }
              }
            ]
          },
          {
            path: 'cadastroDae',
            name: 'dae/cadastroDae',
            component: CadastroDae,
            meta: {
              perfis: perfisFinanceiro,
              ...setRouteGroup('FINANCEIRO_CAIXA_DE_ENTRADA')
            }
          },
          {
            path: 'resumoDae',
            name: 'dae/resumoDae',
            component: ResumoDae,
            meta: {
              perfis: perfisFinanceiro,
              ...setRouteGroup('FINANCEIRO_CAIXA_DE_ENTRADA')
            }
          }
        ]
      }
    ]
  }
]

export default financeiro



// WEBPACK FOOTER //
// ./src/router/financeiro.js